import '.d{display:flex;}.ssr-plugin'
import '.bf{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { InitiativeCreatePageLayout } from '@app/pages/layout/InitiativeCreatePageLayout'
import { PhaseCard } from './blocks/PhaseCard'
import { useState } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { Modal } from '@app/components/blocks/modal/Modal'
import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import { styled } from 'inlines'

const statusIcons = {
  alreadyBuilt: '🛋️',
  stillToBuild: '🧱',
} as const

export const InitiativeCreation = () => {
  const translations = useTranslations().app.dashboard.initiative.creation
  const [_, navigate] = useLocation()
  const isMobile = useMediaQuery()
  const [exitConfirmationOpen, setExitConfirmationOpen] = useState(false)

  return (
    <InitiativeCreatePageLayout
      title={translations.createInitiative}
      onClose={() => setExitConfirmationOpen(true)}
    >
      <div className="d bf t ax"
      >
        <Column
          gap="3rem"
          alignItems="center"
          style={{
            width: '100%',
            maxWidth: '56rem',
          }}
        >
          <Title.H2 style={{ textAlign: 'center', margin: 0 }}>
            {translations.statusSelectionTitle}
          </Title.H2>
          <Row
            gap="1.5rem"
            style={{
              width: '100%',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: 'stretch',
            }}
          >
            <PhaseCard
              icon={statusIcons.alreadyBuilt}
              title={translations.statusAlreadyBuiltTitle}
              description={translations.statusAlreadyBuiltDescription}
              selected={false}
              onClick={() => navigate(pages.dashboardStartInitiativeLiving)}
            />
            <PhaseCard
              icon={statusIcons.stillToBuild}
              title={translations.statusStillToBuildTitle}
              description={translations.statusStillToBuildDescription}
              selected={false}
              onClick={() => navigate(pages.dashboardStartInitiativeMenu)}
            />
          </Row>
        </Column>
      </div>
      <Modal
        title={translations.closeModalTitle}
        isOpen={exitConfirmationOpen}
        onClose={() => setExitConfirmationOpen(false)}
        onConfirm={() => navigate(pages.dashboardInitiatives)}
      >
        <Text.Medium style={{ whiteSpace: 'preserve', width: '20rem' }}>
          {translations.closeModalContent}
        </Text.Medium>
      </Modal>
    </InitiativeCreatePageLayout>
  )
}
